import { RouteConfig } from 'vue-router'
import HomeV2 from '@/pages/home-v2/index.vue'
import ProtocolList from 'pages/protocol-list.vue'
import PolicyList from '@/pages/policy-list.vue'

const routes: Array<RouteConfig> = [
  {
    path: '/home',
    name: 'home',
    component: HomeV2
  },
  {
    path: '/home-v2',
    name: 'homeV2',
    component: HomeV2
  },
  {
    path: '/protocol-list',
    name: 'protocolList',
    component: ProtocolList,
    props: (route) => ({
      contentType: route.query.contentType
    })
  },
  {
    path: '/policy-list',
    name: 'policyList',
    component: PolicyList
  }
]

export default routes
